// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var foreground = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.desktop, [
            BsCssJs$PrezzeeRibbon.flexDirection("column"),
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.justifyContent("flexEnd"),
            BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(23))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.tablet, [
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(30)),
            BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(20)),
            BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(22)),
            BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(40))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.mobile, [
            BsCssJs$PrezzeeRibbon.flexDirection("column"),
            BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(23))
          ])
    ]);

var contentWrapper = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.tablet, [
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.flexDirection("column"),
            BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(25)),
            BsCssJs$PrezzeeRibbon.minWidth(BsCssJs$PrezzeeRibbon.zero),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100))
          ])]);

var vAlignCenter = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.justifyContent("center"))]);

var hAlignCenter = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.textAlign("center")]);

var Styles = {
  foreground: foreground,
  contentWrapper: contentWrapper,
  vAlignCenter: vAlignCenter,
  hAlignCenter: hAlignCenter
};

function SmallHeroTile__Foreground(props) {
  var hAlign = props.hAlign;
  var vAlign = props.vAlign;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var vAlign$1 = vAlign !== undefined ? vAlign : /* Default */0;
  var hAlign$1 = hAlign !== undefined ? hAlign : /* Default */0;
  var vAlignCss = vAlign$1 >= 2 ? vAlignCenter : "";
  var hAlignCss = hAlign$1 >= 2 ? hAlignCenter : "";
  return JsxRuntime.jsxs("div", {
              children: [
                props.image,
                JsxRuntime.jsx("div", {
                      children: props.children,
                      className: contentWrapper
                    })
              ],
              className: Classnames([
                    foreground,
                    vAlignCss,
                    hAlignCss,
                    className$1
                  ])
            });
}

var make = SmallHeroTile__Foreground;

export {
  Styles ,
  make ,
}
/* foreground Not a pure module */
